import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { CIRCUIT_CATEGORIES as CircuitCategory, EQUIPMENT_TYPE as EquipmentType } from '../../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { planTypeOptions, getVendorDetails, getAddresses } from '../../order-request.functions';
import { BUSINESS_CASE } from '../../../../../constants/external-constants';

import { actions } from 'react-redux-form';

import {
    locationModelA
    , subscriptionModelA
    , businessModelA

    //ACTIONS
    , setUserLocation
    , setCountryOptions
    , setAddressOptions
    , setPlanOptions
    , setVendorOptions
    , setSimOptions
    , setVendorDetails
    , setServiceTypeDetails
    , setDeviceOptions
    , setOrderOptions
    , setCircuitTypes
    , setDeviceAccessories
    , setPrimaryPlanDetails
    , setPurposeOfUseOptions
    , setBusinessCaseOptions
    , setShowDeviceOptions
    , setShowOtherAddress
    , setEmployeeEquipmentProductNames
    , setEmployeeEquipmentOnprogressProductNames
    , setFormSubmitted
    , setCustomerId

    , setCountryLoading
    , getCountryList
    , setAddressLoading
    , setVendorLoading
    , setMobServiceTypeLoading
    , setCircuitTypesLoading
    , setPlanOptionLoading
    , setAllInitialState
    , getNewMobileRequest
} from './../../../../../constants/model-reducers/external/request/wireless-request/new-mobile-subscription.settings';

export const locationModelAInitialState = locationModelA;
export const subscriptionModelAInitialState = subscriptionModelA;
export const businessModelAInitialState = businessModelA;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , simOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , orderOptions: []
    , circuitTypes: []
    , deviceOptions: []
    , deviceAccessories: []
    , vendorDetails: {
        Currency: ''
    }
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , primaryPlanDetail: { ...planDetailConst }
    , purposeOfUseOptions: []
    , businessCaseOptions: []
    , employeeEquipmentProductNames: []
    , employeeEquipmentOnprogressProductNames: []
    , showDeviceOptions: false
    , showOtherAddress: false
    , formSubmitted: false
    , isAmending: false
    , isStripeUpdated: false
    , renderLimit: 1

    , countryPage: 1
    , hasMoreCountry: true
    , isCountryLoading: false

    , addressPage: 1
    , hasMoreAddress: true
    , isAddressLoading: false

    , vendorOptions:[]
    , vendorPage: 1
    , hasMoreVendor: true
    , isVendorLoading: false

    , circuitTypePage: 1
    , hasMoreCircuitType: true
    , isCircuitTypeLoading: false

    , mobServiceTypePage: 1
    , hasMoreMobServiceType: true
    , isMobServiceTypeLoading: false

    , planTypePage: 1
    , hasMorePlanType: true
    , isPlanTypeLoading: false
    , newMobileRequestOptions: []
});

const initialState = defaultState();

export const newMobileSubscriptionActions = {

    getCountryList: () => async (dispatch) => {
        getCountries(dispatch, 1, '');
    },

    getNewMobileFormData: (orderId) => async (dispatch, state) => {
        const pageIndex = 1;
        const pageSize = 15;
        const { requestTypeId, requestOnBehalfData, isRequestOnBehalfToggle } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;
        const { wirelessLocationFormA, wirelessSubscriptionFormA, wirelessBusinessFormA } = state().form;
        var robData = {
            "userId": sessionStorage.UserID,
            "employeeID": requestOnBehalfData.EmployeeId,           
            "enterpriseId": requestOnBehalfData.Eid,           
            "requestInBehalfId": null
        }

        var data = {
            RequestTypeId: requestTypeId
            , OrderId: isAmending ? requestData?.Order?.OrderId : 0
            , User: requestOnBehalfData.EmployeeId ? { ...robData } : { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);
        
        if (res != null) {
            const countryName = wirelessLocationFormA.country ? wirelessLocationFormA.country : isAmending ? requestData?.BillingAddress?.CountryName ?? '' : '';

            dispatch({ type: setUserLocation, data: res.UserLocation });
            await getCountries(dispatch, pageIndex, countryName);
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
            dispatch({ type: setBusinessCaseOptions, data: res.BusinessJustification });
            dispatch({ type: setShowOtherAddress, data: res.ShowOtherAddress });
            dispatch({ type: setEmployeeEquipmentProductNames, data: res.EmployeeEquipmentProductNames });
            dispatch({ type: setEmployeeEquipmentOnprogressProductNames, data: res.EmployeeEquipmentProductNamesOnProgressOrders });

            if (orderId) {
                var userData = getUserData();
                if (requestData.Order.IsRequestedInBehalf) {
                    userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
                }

                dispatch(actions.change('wirelessLocationFormA.isAmending', isAmending));
                const { showOtherAddress } = state().newMobileRequest;
                const addressValue = showOtherAddress ? 'Other' : requestData.BillingAddress.DeliveryAddress;
                // During update of wireless form data, it should be loaded in the display form but once the values are not present or undefined we will load data from the API return.
                let isOtherLocation = wirelessLocationFormA.locationId !== '' && wirelessLocationFormA.locationId !== undefined && wirelessLocationFormA.locationId !== 0 ?
                    (wirelessLocationFormA.locationId === -1 ? true : false) : requestData.BillingAddress.IsOtherLocation;

                await getAddresses(dispatch, setAddressOptions, requestData.BillingAddress.CountryCode, isOtherLocation, pageIndex, addressValue, setAddressLoading);
                await getVendorOptions(dispatch, state, wirelessLocationFormA.country != '' ? wirelessLocationFormA.country : requestData.BillingAddress.CountryName, isAmending, pageIndex, requestData.Subscription.VendorName);
                await getCircuitTypes(dispatch, CircuitCategory.mobile, pageIndex, pageSize, requestData.Subscription.CircuitType);
                await planTypeOptions(dispatch, setPlanOptions, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, pageIndex, requestData.Subscription.Plan, setPlanOptionLoading);
                await getMobileServiceTypeOptions(dispatch, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, userData.employeeID, pageIndex, pageSize, requestData.Subscription.Device?.EquipmentModel);

                if (isOtherLocation === true) {
                    dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddressId', wirelessLocationFormA.otherDeliveryAddressId !== 0 && wirelessLocationFormA.otherDeliveryAddressId !== undefined ?
                        wirelessLocationFormA.otherDeliveryAddressId : requestData.BillingAddress.OtherDeliveryAddressId));
                    dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', wirelessLocationFormA.otherDeliveryAddress !== '' && wirelessLocationFormA.otherDeliveryAddress !== undefined ?
                        wirelessLocationFormA.otherDeliveryAddress : requestData.BillingAddress.OtherDeliveryAddress));
                    dispatch(actions.change('wirelessLocationFormA.locationId', wirelessLocationFormA.locationId !== '' && wirelessLocationFormA.locationId !== 0 && wirelessLocationFormA.locationId !== undefined ? wirelessLocationFormA.locationId :requestData.BillingAddress.LocationId));
                    dispatch(actions.change('wirelessLocationFormA.deliveryAddress', wirelessLocationFormA.deliveryAddress !== '' || wirelessLocationFormA.deliveryAddress !== undefined ?
                        wirelessLocationFormA.deliveryAddress : requestData.BillingAddress.DeliveryAddress))
                    dispatch(actions.change('wirelessLocationFormA.country', wirelessLocationFormA.country !== '' ? wirelessLocationFormA.country : requestData.BillingAddress.CountryName));
                    dispatch(actions.change('wirelessLocationFormA.countryCode', wirelessLocationFormA.countryCode !== '' ? wirelessLocationFormA.countryCode : requestData.BillingAddress.CountryCode));
                }
                else {
                    dispatch(actions.change('wirelessLocationFormA.deliveryAddress', wirelessLocationFormA.deliveryAddress !== '' ? wirelessLocationFormA.deliveryAddress : requestData.BillingAddress.DeliveryAddress));
                    dispatch(actions.change('wirelessLocationFormA.locationId', wirelessLocationFormA.locationId !== '' && wirelessLocationFormA.locationId !== 0 ? wirelessLocationFormA.locationId : requestData.BillingAddress.LocationId));
                    dispatch(actions.change('wirelessLocationFormA.country', wirelessLocationFormA.country !== '' ? wirelessLocationFormA.country : requestData.BillingAddress.CountryName));
                    dispatch(actions.change('wirelessLocationFormA.countryCode', wirelessLocationFormA.countryCode !== '' ? wirelessLocationFormA.countryCode : requestData.BillingAddress.CountryCode));
                }

                if (isRequestOnBehalfToggle) {
                    return;
                } 
                let circuitTypeId = wirelessSubscriptionFormA.circuitTypeId !== '' &&  wirelessSubscriptionFormA.circuitTypeId !== undefined ? wirelessSubscriptionFormA.circuitTypeId : requestData.Subscription.CircuitTypeId;
                let vendorId = wirelessSubscriptionFormA.vendorDetailId !== '' ? wirelessSubscriptionFormA.vendorDetailId : requestData.Subscription.VendorDetailId;
                let planId = wirelessSubscriptionFormA.planId !== '' && wirelessSubscriptionFormA.planId !== 0 ? wirelessSubscriptionFormA.planId : requestData.Subscription.PlanDetails.PlanId;
                dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', vendorId));
                dispatch(actions.change('wirelessSubscriptionFormA.circuitTypeId', circuitTypeId));
                dispatch(actions.change('wirelessSubscriptionFormA.RequestTypeId', res.RequestTypeId));
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', wirelessSubscriptionFormA.mobileServiceModel && wirelessSubscriptionFormA.mobileServiceModel.length > 0 ?
                    wirelessSubscriptionFormA.mobileServiceModel : requestData.Subscription.MobileServiceModel));
                dispatch(actions.change('wirelessSubscriptionFormA.equipmentCatalogId', wirelessSubscriptionFormA.equipmentCatalogId !== '' && wirelessSubscriptionFormA.equipmentCatalogId !== 0 && wirelessSubscriptionFormA.equipmentCatalogId !== undefined ? 
                    wirelessSubscriptionFormA.equipmentCatalogId : requestData.Subscription.EquipmentCatalogId));
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName', wirelessSubscriptionFormA.mobileServiceModel?.[0]?.EquipmentModel
                    ?? requestData.Subscription.EquipmentProductName));
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId', wirelessSubscriptionFormA.mobileServiceModel?.[0]?.EquipmentTypeId
                    ?? requestData.Subscription.MobileServiceModel?.[0]?.EquipmentTypeId ?? 0));
                dispatch(actions.change('wirelessSubscriptionFormA.equipmentInventoryId', wirelessSubscriptionFormA.equipmentInventoryId !== '' &&  wirelessSubscriptionFormA.equipmentInventoryId !== undefined ? 
                    wirelessSubscriptionFormA.equipmentInventoryId : requestData.Subscription.EquipmentInventoryId));
                dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', wirelessSubscriptionFormA.phoneCaseAccessory === true ? wirelessSubscriptionFormA.phoneCaseAccessory : requestData.Subscription.PhoneCaseAccessory));
                dispatch(actions.change('wirelessSubscriptionFormA.planId', wirelessSubscriptionFormA.planId !== '' && wirelessSubscriptionFormA.planId !== 0 ? wirelessSubscriptionFormA.planId : requestData.Subscription.PlanId));
                dispatch(actions.change('wirelessBusinessFormA.purposeOfUseId', wirelessSubscriptionFormA.purposeOfUseId !== '' && wirelessSubscriptionFormA.purposeOfUseId !== undefined ? 
                    wirelessSubscriptionFormA.purposeOfUseId : requestData.BusinessJustification.PurposeOfUseId));
                dispatch(actions.change('wirelessBusinessFormA.busJustiCodeDetailId', wirelessBusinessFormA.busJustiCodeDetailId !== '' && wirelessBusinessFormA.busJustiCodeDetailId !== undefined && wirelessBusinessFormA.busJustiCodeDetailId !== 0 ?
                    wirelessBusinessFormA.busJustiCodeDetailId : requestData.BusinessJustification.BusJustiCodeDetailId));
                dispatch(actions.change('wirelessBusinessFormA.businessJustification', wirelessBusinessFormA.businessJustification !== '' && wirelessBusinessFormA.businessJustification !== undefined ?
                    wirelessBusinessFormA.businessJustification : requestData.BusinessJustification.BusinessJustification));
                dispatch(actions.change('wirelessBusinessFormA.additionalInformation', wirelessBusinessFormA.additionalInformation !== '' && wirelessBusinessFormA.additionalInformation !== undefined ?
                    wirelessBusinessFormA.additionalInformation : requestData.BusinessJustification.AdditionalInformation));
                dispatch(actions.change('wirelessBusinessFormA.termAgreement', wirelessBusinessFormA.termAgreement !== '' && wirelessBusinessFormA.termAgreement !== undefined ?
                    wirelessBusinessFormA.termAgreement : requestData.BusinessJustification.TermAgreement));

                updatePlanDetails(dispatch, planId);
                dispatch({ type: setPrimaryPlanDetails, data: requestData.Subscription.PlanDetails.planDetailsModel });                
            }
        }
    }
    , setRequestorAddress: () => async (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().newMobileRequest;
        const { requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        await getAddresses(dispatch, setAddressOptions, userLocation.CountryCode, showOtherAddress, pageIndex, location.DeliveryAddress, setAddressLoading);
        await getCountries(dispatch, 1, location.CountryName);

        dispatch(actions.change('wirelessLocationFormA.country', location.CountryName));
        dispatch(actions.change('wirelessLocationFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessLocationFormA.locationId', location.LocationId));
        dispatch(actions.change('wirelessLocationFormA.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', ''));

    }
    , onAddressSelect: (model, value) => (dispatch, state) => {

        const { addressOptions } = state().newMobileRequest;

        dispatch(actions.change(model, value));

        if (model == 'wirelessLocationFormA.locationId' && value) {
            dispatch(actions.reset('wirelessLocationFormA.deliveryAddress'));
            dispatch(actions.reset('wirelessLocationFormA.otherDeliveryAddress'));
            const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
            dispatch(actions.change('wirelessLocationFormA.deliveryAddress', deliveryAddress));
            dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', ''));
        }

        const isOtherAddress = value.toString() == '-1' ? true : false;
        dispatch({ type: setShowOtherAddress, data: isOtherAddress });

    }
    , onCountrySelect: (model, value) => (dispatch, state) => {
        const { countryOptions, showOtherAddress } = state().newMobileRequest;
        const pageIndex = 1;

        dispatch(actions.change(model, value));

        if (value) {
            let country = countryOptions.find(o => o['Key'] === value).Value;
            dispatch(actions.change('wirelessLocationFormA.country', country));
        }
        dispatch(actions.reset('wirelessLocationFormA.locationId', ''));
        dispatch(actions.reset('wirelessLocationFormA.deliveryAddress', ''));
        dispatch(actions.reset('wirelessLocationFormA.otherDeliveryAddress', ''))
        dispatch(actions.reset('wirelessSubscriptionFormA'));

        getAddresses(dispatch, setAddressOptions, value, showOtherAddress, pageIndex, '', setAddressLoading);

    }
    , handleCountrySearch: (query) => (dispatch, state) => {
        getCountries(dispatch, 1, query);
    }
    , loadMoreCountry: (searchString) => (dispatch, state) =>{
        const { countryPage } = state().newMobileRequest;

        getCountries(dispatch, countryPage + 1, searchString);
    }

    , handleAddressSearch: (searchString) => (dispatch, state) => {
        const { showOtherAddress } = state().newMobileRequest;
        const { BillingAddress } = state().requestDetail.requestData;
        const { wirelessLocationFormA } = state().form;
        const countryCode = wirelessLocationFormA.countryCode !== ''
                            ? wirelessLocationFormA.countryCode
                            : (BillingAddress?.CountryCode ?? '');
        const pageIndex = 1;

        getAddresses(dispatch, setAddressOptions, countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);
    }
    , loadMoreAddress: (searchString) => (dispatch, state) => {
        const { addressPage, showOtherAddress } = state().newMobileRequest;
        const { wirelessLocationFormA } = state().form;
        const pageIndex = addressPage + 1;

        getAddresses(dispatch, setAddressOptions, wirelessLocationFormA.countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);

    }
    , handleMobServiceTypeSearch: (searchString) => (dispatch, state) => {
        const { wirelessSubscriptionFormA } = state().form;
        const { Subscription } = state().requestDetail.requestData;
        var userData = getUserData();
        const vendorId = wirelessSubscriptionFormA.vendorDetailId !== '' ? wirelessSubscriptionFormA.vendorDetailId : Subscription.VendorDetailId;
        const circuitTypeId = wirelessSubscriptionFormA.circuitTypeId !== '' && wirelessSubscriptionFormA.circuitTypeId !== undefined ? wirelessSubscriptionFormA.circuitTypeId : Subscription?.CircuitTypeId ?? 0;

        getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, userData.employeeID, 1, 15, searchString);
    }
    , loadMoreMobServiceType: (searchString) => (dispatch, state) => {
        const { mobServiceTypePage } = state().newMobileRequest;
        const pageIndex = mobServiceTypePage + 1
        const { wirelessSubscriptionFormA } = state().form;
        var userData = getUserData();
        
        getMobileServiceTypeOptions(dispatch, wirelessSubscriptionFormA.vendorDetailId, wirelessSubscriptionFormA.circuitTypeId, userData.employeeID, pageIndex, 15, searchString);
    }
    , onVendorSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, parseInt(value)));

        dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', parseInt(value)));
        dispatch(actions.reset('wirelessSubscriptionFormA.circuitTypeId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.equipmentCatalogId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.mobileServiceModel'));
        dispatch(actions.reset('wirelessSubscriptionFormA.equipmentInventoryId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.accessoryDetailsModel'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planDetailsModel'));
        dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, parseInt(value))
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

        getCircuitTypes(dispatch, CircuitCategory.mobile, 1, 15, '');

    }
    , onCircuitTypeSelect: (circuitTypeId) => async (dispatch, state) => {
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;

        var userData = getUserData();
        if (isAmending) {
            if (requestData.Order.IsRequestedInBehalf) {
                userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
            }
        }
        else {
            if (isRequestOnBehalf) {
                userData.employeeID = requestOnBehalfData.EmployeeId;
            }
        }

        const { wirelessSubscriptionFormA } = state().form;
        const pageIndex = 1;

        dispatch(actions.setErrors('wirelessSubscriptionFormA.equipmentInventoryId', false));

        dispatch(actions.change('wirelessSubscriptionFormA.circuitTypeId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.equipmentCatalogId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.accessoryDetailsModel'));
        dispatch(actions.reset('wirelessSubscriptionFormA.mobileServiceModel'));
        dispatch(actions.reset('wirelessSubscriptionFormA.equipmentInventoryId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planDetailsModel'));
        dispatch(actions.reset('primaryPlanDetail.ComponentCost'));
        dispatch(actions.reset('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });

        getMobileServiceTypeOptions(dispatch, wirelessSubscriptionFormA.vendorDetailId, circuitTypeId, userData.employeeID, pageIndex, 15);
        planTypeOptions(dispatch, setPlanOptions, wirelessSubscriptionFormA.vendorDetailId, circuitTypeId, pageIndex, '', setPlanOptionLoading);
    }
    , onServiceTypeSelect: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch(actions.reset('wirelessSubscriptionFormA.mobileServiceModel'));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        getServiceTypeDetails(dispatch, state, value);
        dispatch(actions.reset('wirelessSubscriptionFormA.equipmentInventoryId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planId'));
        dispatch(actions.reset('wirelessSubscriptionFormA.planDetailsModel'));
        dispatch(actions.reset('primaryPlanDetail.ComponentCost'));
        dispatch(actions.reset('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    }
    , onPlanSelect: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', subscriptionModelA.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanDetails(dispatch, value);

    }
    , handlePlanTypeSearch: (searchString) => (dispatch, state) => {
        const { wirelessSubscriptionFormA } = state().form;
        const { Subscription } = state().requestDetail.requestData;
        const vendorId = wirelessSubscriptionFormA.vendorDetailId !== '' ? wirelessSubscriptionFormA.vendorDetailId : Subscription.VendorDetailId;
        const circuitTypeId =   wirelessSubscriptionFormA.circuitTypeId !== '' && wirelessSubscriptionFormA.circuitTypeId !== undefined
                                    ? wirelessSubscriptionFormA.circuitTypeId
                                    : (Subscription?.CircuitTypeId ?? 0);
        const pageIndex = 1;

        planTypeOptions(dispatch, setPlanOptions, vendorId, circuitTypeId, pageIndex, searchString, setPlanOptionLoading);
    }
    , loadMorePlanType: (searchString) => (dispatch, state) => {
        const { planTypePage } = state().newMobileRequest;
        const { wirelessSubscriptionFormA } = state().form;
        const pageIndex = planTypePage + 1;

        planTypeOptions(dispatch, setPlanOptions, wirelessSubscriptionFormA.vendorDetailId, wirelessSubscriptionFormA.circuitTypeId, pageIndex, searchString, setPlanOptionLoading);
    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().newMobileRequest;
        const { wirelessSubscriptionFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessSubscriptionFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessSubscriptionFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessSubscriptionFormA.accessoryDetailsModel', newAccessories));
    }
    , onSubscriptionFormLoad: () => async (dispatch, state) => {
        const { wirelessLocationFormA, wirelessSubscriptionFormA } = state().form;
        const { isAmending } = state().requestDetail;


        if (wirelessSubscriptionFormA.vendorDetailId !== '' && isAmending !== true) {
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, wirelessSubscriptionFormA.vendorDetailId);
        }


        if (wirelessSubscriptionFormA.vendorDetailId !== '') {
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, wirelessSubscriptionFormA.vendorDetailId);
        }

        var data = {
            ...wirelessLocationFormA
        };

        getVendorOptions(dispatch, state, wirelessLocationFormA.country, isAmending, 1, '')

    }
    , handleVendorSearch: (searchString) => (dispatch, state) => {
        const { wirelessLocationFormA } = state().form;
        const { BillingAddress } = state().requestDetail.requestData;
        const country = wirelessLocationFormA.country !== '' ? wirelessLocationFormA.country : BillingAddress.CountryName;

        if (searchString !== "") {
            getVendorOptions(dispatch, state, country, false, 1, searchString)
        }
    }

    , loadMoreVendor: (searchString) => (dispatch, state) => {
        const { vendorPage, renderLimit } = state().newMobileRequest;
        const { wirelessLocationFormA } = state().form;

        if (renderLimit === 1) {
            getVendorOptions(dispatch, state, wirelessLocationFormA.country, false, vendorPage + 1, searchString, renderLimit)
        }
    }

    , handleCircuitTypeSearch: (query) => (dispatch, state) => {

        if (query !== "") {

            getCircuitTypes(dispatch, CircuitCategory.mobile, 1, 15, query);
        }
    }

    , loadMoreCircuitType: (searchString) => (dispatch, state) => {
        const { circuitTypePage } = state().newMobileRequest;

        getCircuitTypes(dispatch, CircuitCategory.mobile, circuitTypePage + 1, 15, searchString);
    }
    , onBussinessCaseSelect: (model, value) => async (dispatch, state) => {
        const { businessCaseOptions } = state().newMobileRequest;
        dispatch(actions.change(model, value));

        const textValue = businessCaseOptions.length > 0 ? businessCaseOptions.find(r => r.Key == value).Value : '';
        if (value == BUSINESS_CASE.other) {
            dispatch(actions.change('wirelessBusinessFormA.businessJustification', ''));
        } else {
            dispatch(actions.change('wirelessBusinessFormA.businessJustification', textValue));
        }
    }
    , resetNewMobileForm: () => (dispatch, state) => {
        resetNewMobileForm(dispatch);
    }
    , fetchNewMobileOptions: () => async (dispatch, state) => {
        var res = await httpGet('external/orderRequest/newMobileRequestOptions');
        dispatch({ type: getNewMobileRequest, data: res });
    }
    , submitRequest: (paymentInfo=null) => async (dispatch, state) => {

        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelessLocationFormA, wirelessSubscriptionFormA, wirelessBusinessFormA } = state().form;
        const { requestData, isAmending } = state().requestDetail;
        
        var planComponents = wirelessSubscriptionFormA.planDetailsModel.length > 0 ? wirelessSubscriptionFormA.planDetailsModel[0].dataItem : [];

        dispatch(actions.change('wirelessSubscriptionFormA.planDetails.planComponents', planComponents));
        dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddressId', requestData.OtherLocationID ));

        let userData = getUserData();
        const requestorEmployeeID = userData.employeeID

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            SubscriptionModel: { ...state().form.wirelessSubscriptionFormA, EquipmentInventory: wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentModel }
            , BusinessJustificationModel: { ...wirelessBusinessFormA }
            , User: {
                ...userData
            }
            , NoEmail: true
            , RequestTypeId: wirelessSubscriptionFormA.RequestTypeId
            , IsAmending: isAmending
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , CircuitId: isAmending ? requestData.CircuitId : 0
            , EquipmentInventoryId: isAmending ? requestData.Subscription.EquipmentCatalogId : 0
            , CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isAmending ? requestData.OrderHistoryId : 0
            , OrderInfoId: isAmending ? requestData.OrderInfoId : 0
            , LocationOrderModel: {
                CountryCode: wirelessLocationFormA.countryCode,
                Country: isRequestOnBehalf ? requestOnBehalfData.LocationModel.CountryName : wirelessLocationFormA.country,
                LocationCountryID: isRequestOnBehalf ? requestOnBehalfData.LocationModel.CountryId : wirelessLocationFormA.locationCountryID,
                LocationId: wirelessLocationFormA.locationId,
                OtherDeliveryAddress: wirelessLocationFormA.otherDeliveryAddress,
                DeliveryAddress: wirelessLocationFormA.deliveryAddress,
                OtherLocationID: isAmending ? requestData.otherLocationID : wirelessLocationFormA.otherLocationID
            }
            , RequestorID: Number(requestorEmployeeID)
            , StripeCustomerId: paymentInfo?.customerId ?? null

        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        dispatch({ type: setFormSubmitted, data: false });

        return res;
    }
    , updateCustomerId: (orderId=0, customerId='') => async (dispatch, state) => {
        var res = await httpPost(`external/orderRequest/updatecustomerId/${orderId}/${customerId}`)
        if(res) {
            dispatch({
                type: setCustomerId,
                payload: true
            });
            return res;
        } else {
            dispatch({
                type: setCustomerId,
                payload: false
            })
        }
    }
}

function resetNewMobileForm(dispatch) {   
    dispatch({ type: setAllInitialState })
    dispatch(actions.reset('wirelessLocationFormA.country'))
    dispatch(actions.reset('wirelessLocationFormA.countryCode'));
    dispatch(actions.reset('wirelessLocationFormA.deliveryAddress'));
    dispatch(actions.reset('wirelessLocationFormA.otherDeliveryAddress'));
    dispatch(actions.reset('wirelessLocationFormA.locationId'));
    dispatch(actions.reset('wirelessLocationFormA.isAmending'));
    dispatch(actions.reset('wirelessLocationFormA.otherDeliveryAddressId'));
    dispatch(actions.reset('wirelessSubscriptionFormA'));
    dispatch(actions.reset('wirelessBusinessFormA'));
}

async function getCountries(dispatch, page = 1, searchString = '') {
    const pageSize = 15;
    dispatch({
        type: setCountryLoading,
        payload: true
    });
    let url = `external/orderRequest/getCountryList/${page}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url)

    try {
        if (res != null) {
            dispatch({
                type: getCountryList,
                payload: {
                    country: res,
                    countryPage: page
                }
            });
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        } else {
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        }
    } catch (error) {
        return null
    } finally {
        dispatch({
            type: setCountryLoading,
            payload: false
        });
    }
}
async function getDeviceAccessories(dispatch, vendorId) {

    var res = await httpGet('external/orderRequest/getEquipmentData/' + vendorId + '/' + EquipmentType.Accessory);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getServiceTypeDetails(dispatch, state, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', res));

        const { isAmending } = state().requestDetail;
        if (isAmending) {
            const { employeeEquipmentProductNames, employeeEquipmentOnprogressProductNames } = state().newMobileRequest;
            const { wirelessSubscriptionFormA } = state().form;
            const termAgreement = (employeeEquipmentProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value) || employeeEquipmentOnprogressProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value))
                && (wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId.value === EquipmentType.Device);

            dispatch(actions.change('wirelessBusinessFormA.termAgreement', termAgreement ? true : false));
        }  

    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', []));
    }

}


async function updatePlanDetails(dispatch, id) {
    var res = await httpGet('external/orderRequest/getOrderPlanComponentByPlan/' + id);

    if (res.datatable.length > 0 && res.datatable[0].dataItem.length > 0) {
        var data = res.datatable;

        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', data));

        var primaryPlan = Object.keys(data[0].dataItem)
            .map((key) => data[0].dataItem[key])
            .filter((item) => item.IsPrimary === true);

        if (primaryPlan != null && primaryPlan.length > 0) {
            dispatch({
                type: setPrimaryPlanDetails,
                data: primaryPlan[0]
            });
        }
    }
    return res != null;
}


async function getSimTypes(dispatch) {
    var res = await httpPost('external/orderRequest/getSimTypes');
    if (res != null) {
        dispatch({ type: setSimOptions, data: res });
    }
    return res != null && res.ok !== false;
}

async function getVendorOptions(dispatch, state, country, isAmending, pageIndex = 1, searchString, renderLimit = 1) {
    const pageSize = 15;

    dispatch({
        type: setVendorLoading
        , payload: true
    });

    let url = `external/orderRequest/getVendorsByCountry/${country}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url);

    try {
        if (res) {
            dispatch({
                type: setVendorOptions
                , vendorOptions: res
                , vendorPage: pageIndex
                , renderLimit: renderLimit + 1
            });

            dispatch({
                type: setVendorLoading
                , payload: false
                , renderLimit: 1
            });
        }
        else {
            dispatch({
                type: setVendorOptions
                , vendorOptions: []
                , vendorPage: 1
            });

            dispatch({
                type: setVendorLoading
                , payload: false
                , renderLimit: 1
            });
        }
    }
    catch (e) {
        dispatch({
            type: setVendorOptions
            , vendorOptions: []
            , vendorPage: 1
        });

        dispatch({
            type: setVendorLoading
            , payload: false
            , renderLimit: 1
        });
    }
}

async function getCircuitTypes(dispatch, id, pageIndex = 1, pageSize = 15, searchString = '') {

    dispatch({
        type: setCircuitTypesLoading
        , payload: true
    })

    let url = `external/orderRequest/getCircuitTypesByCategoryId/${id}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }

    try {
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: setCircuitTypes
                , circuitTypeData: res
                , circuitTypePage: pageIndex
            });
        } else {
            dispatch({ type: setCircuitTypes, data: defaultState.circuitTypes });
        }

    }
    catch (e) {
        return null;
    }
    finally {
        dispatch({
            type: setCircuitTypesLoading
            , payload: false
        })
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeId, pageIndex = 1, pageSize = 15, searchString = '') {

    dispatch({
        type: setMobServiceTypeLoading
        , payload: true
    })

    let url = `external/orderRequest/getAllMobileServiceTypesOptions/${vendorId}/${circuitTypeId}/${employeeId}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }

    try {

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: setDeviceOptions
                , payload: {
                    deviceOptions: res
                    , mobServiceTypePage: pageIndex
                }
            });
        } else {
            dispatch({
                type: setDeviceOptions, data: defaultState.deviceOptions
            });
        }
    }
    catch (e) {
        return null
    }
    finally {
        dispatch({
            type: setMobServiceTypeLoading
            , payload: false
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case getCountryList:
            const { country, countryPage } = action.payload;
            const newLocations = Array.isArray(country) ? country : [];
            return {
                ...state,
                countryOptions: countryPage === 1
                    ? newLocations : [...state.countryOptions, ...newLocations]
                , hasMoreCountry: newLocations.length > 0
                , countryPage: countryPage
            };
        case setCountryLoading:
            return {
                ...state,
                isCountryLoading: action.payload
            };
        case setAddressLoading:
            return {
                ...state,
                isAddressLoading: action.payload
            }
        case setAddressOptions:
            const { address, addressPage } = action.payload;
            const newAddress = Array.isArray(address) ? address : [];
            return {
                ...state,
                addressOptions: addressPage === 1
                    ? newAddress : [...state.addressOptions, ...newAddress]
                , addressPage: addressPage
                , hasMoreAddress: newAddress.length > 0
            };
        case setSimOptions:
            return {
                ...state,
                simOptions: action.data
            };
        case setVendorOptions:
            const { vendorOptions, vendorPage, renderLimit } = action;
            const newVendors = Array.isArray(vendorOptions) ? vendorOptions : [];

            return {
                ...state,
                vendorOptions: vendorPage === 1
                    ? newVendors :
                    [...state.vendorOptions,
                        ...newVendors]
                , vendorPage: vendorPage
                , hasMoreVendor: newVendors.length > 0
                , renderLimit: renderLimit
            };
        case setVendorLoading:
            return {
                ...state,
                isVendorLoading: action.payload
                , renderLimit: action.renderLimit
            }
        case setPlanOptions:
            const { planType, planPage } = action.payload;

            return {
                ...state,
                planOptions: planPage === 1 ? planType
                    : [...state.planOptions, ...planType]
                , planTypePage: planPage
                , hasMorePlanType: planType.length > 0
            };
        case setPlanOptionLoading:
            return {
                ...state,
                isPlanTypeLoading: action.payload
            };
        case setOrderOptions:
            return {
                ...state,
                orderOptions: action.data
            };
        case setCircuitTypes:
            const { circuitTypeData, circuitTypePage } = action;

            return {
                ...state,
                circuitTypes: circuitTypePage === 1
                    ? circuitTypeData
                    : [...state.circuitTypes, ...circuitTypeData]
                , circuitTypePage: circuitTypePage
                , hasMoreCircuitType: circuitTypeData.length > 0
            };
        case setCircuitTypesLoading:
            return {
                ...state
                , isCircuitTypeLoading: action.payload
            }
        case setDeviceOptions:
            const { deviceOptions, mobServiceTypePage } = action.payload;
            const newDeviceOptions = Array.isArray(deviceOptions) ? deviceOptions : [];
            return {
                ...state,
                deviceOptions: mobServiceTypePage === 1
                    ? newDeviceOptions : [...state.deviceOptions, ...newDeviceOptions]
                , mobServiceTypePage: mobServiceTypePage
                , hasMoreMobServiceType: newDeviceOptions.length > 0
            };
        case setMobServiceTypeLoading:
            return {
                ...state
                , isMobServiceTypeLoading: action.payload
            }
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetail: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state,
                businessCaseOptions: action.data
            };
        case setShowDeviceOptions:
            return {
                ...state,
                showDeviceOptions: action.data
            };
        case setShowOtherAddress:
            return {
                ...state,
                showOtherAddress: action.data
            };
        case setEmployeeEquipmentProductNames:
            return {
                ...state,
                employeeEquipmentProductNames: action.data
            };
        case setEmployeeEquipmentOnprogressProductNames:
            return {
                ...state,
                employeeEquipmentOnprogressProductNames: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case setCustomerId:
            return {
                ...state,
                isStripeUpdated: action.payload
            };
        case getNewMobileRequest:
            return {
                ...state,
                newMobileRequestOptions: action.data
            };
        case setAllInitialState:
            return {
                ...state,
                initialState
            }
        default: return state;
    }
}